import React from 'react';
import { HiOutlineArrowLeft } from 'react-icons/hi';

/**
 * ArrowLeftIcon
 * Ikona šípky smerom doľava na označenie návratu späť.
 */
const ArrowLeftIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <HiOutlineArrowLeft className={className} {...props} />
);

export default ArrowLeftIcon;

